import * as Yup from 'yup';
import { translate } from 'helpers/intl';
import messages from 'containers/PasswordRecoveryPages/InsertNewPassword/messages';
import { STRONG_PASSWORD_REGEX } from 'containers/PasswordRecoveryPages/constants';

export default (props: any) =>
  Yup.object().shape({
    newPassword: Yup.string()
      .min(10, translate({ ...messages.passwordMsg }, props))
      .matches(
        STRONG_PASSWORD_REGEX,
        translate({ ...messages.confirmPasswordError }, props),
      )
      .required(translate({ ...messages.requiredField }, props)),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref('newPassword')],
        translate({ ...messages.confirmPasswordError }, props),
      )
      .required(translate({ ...messages.requiredField }, props)),
  });
